import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);



const types = {
	PARENT_SHOW_FN : 'PARENT_SHOW_FN',

	PARENT2_SHOW_FN : 'PARENT2_SHOW_FN',

	PARENT3_SHOW_FN : 'PARENT3_SHOW_FN',

	PARENT4_SHOW_FN : 'PARENT4_SHOW_FN',

	PARENT5_SHOW_FN : 'PARENT5_SHOW_FN',

	LOADING_SHOW_FN : 'LOADING_SHOW_FN',
	LOADING_HIDDEN_FN : 'LOADING_HIDDEN_FN',

	ROUTER_QUWEY_FN: 'ROUTER_QUWEY_FN',

	RIGHT_FN: 'LOGIN_FN',
};

const state = {
	parentShow:true,
	parent2Show:true,
	parent3Show:true,
	parent4Show:true,
	parent5Show:true,
	routerQuery:'',
	loadingShow:false,
	rightClick:false,
};

const actions = {
	parentShowFn: ({
		commit
	}) => {
		commit(types.PARENT_SHOW_FN);
	},

	parent2ShowFn: ({
		commit
	}) => {
		commit(types.PARENT2_SHOW_FN);
	},

	parent3ShowFn: ({
		commit
	}) => {
		commit(types.PARENT3_SHOW_FN);
	},

	parent4ShowFn: ({
		commit
	}) => {
		commit(types.PARENT4_SHOW_FN);
	},

	parent5ShowFn: ({
		commit
	}) => {
		commit(types.PARENT5_SHOW_FN);
	},

	loadingShowFn: ({
		commit
	}) => {
		commit(types.LOADING_SHOW_FN);
	},

	loadingHiddenFn: ({
		commit
	}) => {
		commit(types.LOADING_HIDDEN_FN);
	},

	routerQueryFn: ({
		commit
	}) => {
		commit(types.ROUTER_QUWEY_FN);
	},

	rightFn: ({
		commit
	}) => {
		commit(types.RIGHT_FN);
	},
}

const mutations = {
	[types.PARENT_SHOW_FN](state) {
		state.parentShow=true;
	},

	[types.PARENT2_SHOW_FN](state) {
		state.parentShow=false;
		state.parent2Show=true;
	},

	[types.PARENT3_SHOW_FN](state) {
		state.parentShow=false;
		state.parent2Show=false;
		state.parent3Show=true;
	},

	[types.PARENT4_SHOW_FN](state) {
		state.parentShow=false;
		state.parent2Show=false;
		state.parent3Show=false;
		state.parent4Show=true;
	},

	[types.PARENT5_SHOW_FN](state) {
		state.parentShow=false;
		state.parent2Show=false;
		state.parent3Show=false;
		state.parent4Show=false;
		state.parent5Show=true;
	},

	[types.LOADING_SHOW_FN](state) {
		state.loadingShow=true;
	},
	[types.LOADING_HIDDEN_FN](state) {
		state.loadingShow=false;
	},


	[types.ROUTER_QUWEY_FN](state,res) {
		state.routerQuery=res;
	},

	[types.RIGHT_FN](state,res) {
		console.log(res);
		state.rightClick=res;
	},
};


const getters = {
	parentShowFn: (state) => {
		return state.parentShow;
	},

	parent2ShowFn: (state) => {
		return state.parent2Show;
	},

	parent3ShowFn: (state) => {
		return state.parent3Show;
	},

	parent4ShowFn: (state) => {
		return state.parent4Show;
	},

	parent5ShowFn: (state) => {
		return state.parent5Show;
	},

	loadingShowFn: (state) => {
		return state.loadingShow;
	},
	loadingHiddenFn: (state) => {
		return state.loadingShow;
	},

	routerQueryFn: (state) => {
		return state.routerQuery;
	},
	rightFn: (state) => {			//判断权限管理
		if(localStorage.aid == 8 ||(localStorage.departmentid == 9 && (localStorage.position == '客服组' || localStorage.position =='解析组')) || localStorage.departmentid == 1 || localStorage.departmentid == 7){
			state.rightClick=true;
		}else{
			state.rightClick=false;
		}
		return state.rightClick;
	},
}


export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters
});



// WEBPACK FOOTER //
// ./src/store/index.js